import swiperRelated from "../../components/swiper-related";
import swiperAside from "../../components/swiper-aside";
import checkCurrentPage from "../checks/check-current-page";
import currentYear from "../common/get-current-year";
import setSvgSize from "../common/set-svg-size";

export default function routingFunctions() {
  checkCurrentPage();
  currentYear();
  setSvgSize();
  swiperRelated();
  swiperAside();
}